import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import Loader from '../../assets/icons/Loader';
import DeepLinkVerification from '../../assets/images/DeepLinkVerification';
import { useBrandingContext } from '../../branding';
import { useBankContext } from '../../dictionaries/context/BankContext';
import RenderText from '../../dictionaries/RenderText';
import { useConfirmIdentityDeepLinkMutation } from '../../generated/graphql';
import { session } from '../../utils/auth';
import { useIdentityConfirmation } from '../IdentificationConfirmation/utils/useIdentityConfirmation';

const REDIRECTION_TIMEOUT = 3_000;
const CLEAR_TOKEN_PARAMS = 'token=undefined&id=undefined';

type DeepLinkValidationProps = {
  path: string;
  token?: string;
  userId?: string;
};

function IdentityConfirmationDeepLinkValidation(props: DeepLinkValidationProps) {
  const { path, token, userId } = props;
  const history = useHistory();
  const { theme } = useBrandingContext();
  const [ bank ] = useBankContext();

  const [ confirmDeepLink, { error: confirmDeepLinkError } ] = useIdentityConfirmation(
    useConfirmIdentityDeepLinkMutation,
    'confirmIdentityDeepLink',
    `${path}/exitosa?${CLEAR_TOKEN_PARAMS}`,
  );

  useEffect(() => {
    if (!token || !userId || session.identityValidated) {
      history.replace(`?${CLEAR_TOKEN_PARAMS}`);
    }
  }, [ token, userId, history ]);

  useEffect(() => {
    const canConfirmDeepLink = !!token && !!userId && !!bank;
    if (!session.identityValidated && canConfirmDeepLink) {
      const timeout = setTimeout(() => {
        confirmDeepLink({
          variables: {
            bank,
            token,
            userId,
          },
        });
      }, REDIRECTION_TIMEOUT);

      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [ bank, token, userId, confirmDeepLink ]);

  useEffect(() => {
    if (confirmDeepLinkError || !bank) {
      history.replace(`/portal/validacion-identidad/opciones?${CLEAR_TOKEN_PARAMS}`, { deepLinkFailed: true });
    }
  }, [ confirmDeepLinkError, bank, history ]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gridGap={theme.spacing(2)}>
      <DeepLinkVerification />
      <Box mt={4}>
        <Loader color={theme.palette.primary.main} />
      </Box>
      <h1>
        <RenderText textKey="validation_deep_link_title_part_1" />&nbsp;
        <Box display="inline" color={theme.palette.primary.main}>
          <RenderText textKey="validation_deep_link_title_part_2" />
        </Box>
      </h1>
    </Box>
  );
}

export default IdentityConfirmationDeepLinkValidation;
